import { render, staticRenderFns } from "./reviewFileDialog.vue?vue&type=template&id=19ce71a5&scoped=true"
import script from "./reviewFileDialog.vue?vue&type=script&lang=js"
export * from "./reviewFileDialog.vue?vue&type=script&lang=js"
import style0 from "./reviewFileDialog.vue?vue&type=style&index=0&id=19ce71a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce71a5",
  null
  
)

export default component.exports